"use client"

import { ReceiptRussianRuble } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ReceiptRussianRubleIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ReceiptRussianRubleIcon = component(Icon)({
  as: ReceiptRussianRuble,
})
